import React, { createContext, useContext, useEffect, useState } from "react";
import { useTenant } from "./TenantContext";
import { getGeo } from "../lib/api";

const SYMBOLS = { GBP: "£", USD: "$", EUR: "€" };
export const CURRENCY_SYMBOLS = SYMBOLS;

const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

// Establishes the customer's display currency: saved choice > coarse country default (server
// cf-ipcountry) > first enabled. Changing it never touches the turf design or AI artwork.
export function CurrencyProvider({ children }) {
  const tenant = useTenant();
  const enabled = tenant?.pricing_meta?.currencies?.enabled || ["GBP"];
  const [currency, setCur] = useState(null);

  useEffect(() => {
    if (currency && enabled.includes(currency)) return;
    const saved = localStorage.getItem("pgt_ccy");
    if (saved && enabled.includes(saved)) { setCur(saved); return; }
    let cancelled = false;
    getGeo()
      .then((g) => { if (!cancelled) setCur(enabled.includes(g.currency) ? g.currency : (enabled[0] || "GBP")); })
      .catch(() => { if (!cancelled) setCur(enabled[0] || "GBP"); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled.join(",")]);

  const setCurrency = (c) => {
    if (!enabled.includes(c)) return;
    localStorage.setItem("pgt_ccy", c);
    setCur(c);
  };

  const value = {
    currency: currency || "GBP",
    ready: !!currency,
    setCurrency,
    symbol: SYMBOLS[currency || "GBP"],
    enabled,
  };
  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}
